import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

import { StyledStack, StyledVpButton } from './styles';

export const VpUpgradePromptBox = ({ title = '', description = '' }) => {
  return (
    <StyledStack gap={2}>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2">{description}</Typography>
      <StyledVpButton size="medium" to="/billing" variant="contained" color="primary">
        Go To Billing
      </StyledVpButton>
    </StyledStack>
  );
};

VpUpgradePromptBox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpUpgradePromptBox/VpUpgradePromptBox.jsx